"use client";

import { Ecommerce } from "@/lib/nexus-app";
import { buildWeeklyOpeningHours } from "@/lib/store-status";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

export default function StoreHoursList({ store }: { store: Ecommerce }) {
  const t = useTranslations("StoreClosed");
  const tWeekdays = useTranslations("Weekdays");

  const weekly = useMemo(() => buildWeeklyOpeningHours(store), [store]);

  if (!weekly.length) {
    return <p className="text-sm text-gray-600">{t("noWeeklyData")}</p>;
  }

  return (
    <ul className="flex flex-col">
      {weekly.map((line) => {
        const [dayName, rest] = line.split(": ");
        const translatedDay = tWeekdays(dayName);
        const formatHours = (value: string) =>
          value.replace(/(\d{1,2}:\d{2})\s*[-–]\s*(\d{1,2}:\d{2})/, "$1 - $2");
        const translatedRest =
          rest === "closed"
            ? t("closed")
            : rest === "no-data"
              ? t("noData")
              : formatHours(rest);
        return (
          <li
            key={line}
            className="flex items-center justify-between border-b border-gray-3 py-3 last:border-b-0 text-sm"
          >
            <span className="font-medium text-gray-900">{translatedDay}</span>
            <span
              className={`tabular-nums text-right ${
                rest === "closed" ? "text-gray-500" : "text-gray-700"
              }`}
            >
              {translatedRest}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
